import React from 'react'
import {useTranslation} from 'react-i18next'
import {AdminCodeStep} from '../../domain/entities/AdminCode.ts'

// The 11-step path a single-use code walks (plus ANULADO) — wire values are
// numerically prefixed by the backend so they sort themselves; keep that
// order here too instead of re-deriving it.
export const ALL_STEPS: AdminCodeStep[] = [
    '01_CREADO', '02_VIAJERO_ASIGNADO', '03_VIAJE_ASIGNADO', '04_ENTREGADO_AL_VIAJERO',
    '05_CANJEADO', '06_CONVERTIDO', '07_ENVIADO_A_IMPRIMIR', '08_EN_PRODUCCION',
    '09_IMPRESO', '10_EN_REPARTO', '11_ENTREGADO', 'XX_ANULADO',
]

export const STEP_LABEL_KEY: Record<AdminCodeStep, string> = {
    '01_CREADO': 'adminCodes.stepCreado',
    '02_VIAJERO_ASIGNADO': 'adminCodes.stepViajeroAsignado',
    '03_VIAJE_ASIGNADO': 'adminCodes.stepViajeAsignado',
    '04_ENTREGADO_AL_VIAJERO': 'adminCodes.stepEntregadoAlViajero',
    '05_CANJEADO': 'adminCodes.stepCanjeado',
    '06_CONVERTIDO': 'adminCodes.stepConvertido',
    '07_ENVIADO_A_IMPRIMIR': 'adminCodes.stepEnviadoAImprimir',
    '08_EN_PRODUCCION': 'adminCodes.stepEnProduccion',
    '09_IMPRESO': 'adminCodes.stepImpreso',
    '10_EN_REPARTO': 'adminCodes.stepEnReparto',
    '11_ENTREGADO': 'adminCodes.stepEntregado',
    'XX_ANULADO': 'adminCodes.stepAnulado',
}

const STEP_STYLE: Record<AdminCodeStep, {bg: string; dot: string}> = {
    '01_CREADO': {bg: 'bg-neutralBlack-100', dot: 'bg-neutralBlack-400'},
    '02_VIAJERO_ASIGNADO': {bg: 'bg-neutralBlack-100', dot: 'bg-neutralBlack-500'},
    '03_VIAJE_ASIGNADO': {bg: 'bg-neutralBlack-100', dot: 'bg-neutralBlack-600'},
    '04_ENTREGADO_AL_VIAJERO': {bg: 'bg-[#E8ECFB]', dot: 'bg-[#3E63DD]'},
    '05_CANJEADO': {bg: 'bg-[#E8ECFB]', dot: 'bg-[#3E63DD]'},
    '06_CONVERTIDO': {bg: 'bg-[#E8ECFB]', dot: 'bg-[#3E63DD]'},
    '07_ENVIADO_A_IMPRIMIR': {bg: 'bg-[#FDF7E6]', dot: 'bg-[#B07A00]'},
    '08_EN_PRODUCCION': {bg: 'bg-warning/15', dot: 'bg-warning'},
    '09_IMPRESO': {bg: 'bg-success/15', dot: 'bg-success'},
    '10_EN_REPARTO': {bg: 'bg-success/15', dot: 'bg-success'},
    '11_ENTREGADO': {bg: 'bg-[#D8F3F6]', dot: 'bg-[#04A3B3]'},
    'XX_ANULADO': {bg: 'bg-danger/15', dot: 'bg-danger'},
}

export const AdminCodeStepPill: React.FC<{
    step: AdminCodeStep
    onClick?: (e: React.MouseEvent) => void
}> = ({step, onClick}) => {
    const {t} = useTranslation('dashboard')
    const style = STEP_STYLE[step] ?? STEP_STYLE['01_CREADO']
    return (
        <span
            onClick={onClick}
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs text-neutralBlack-900 whitespace-nowrap ${style.bg} ${onClick ? 'cursor-pointer hover:brightness-95' : ''}`}
        >
            <span className={`w-[7px] h-[7px] rounded-full flex-none ${style.dot}`}/>
            {t(STEP_LABEL_KEY[step] ?? step)}
        </span>
    )
}
